export enum ErrorType {
  NotFound = 'notFound',
  ServerError = 'serverError',
}
